import * as modal from "../util/modal.ts";

export {checkQuota,canUpload,quotaErrorHandler}


async function checkQuota(){
  var quota = await ApiServer.albumquota();
  if(canUpload(quota)){
    return true;
  }else{
    quotaErrorHandler(quota.rightFlag)
    return false;
  }
}


function canUpload(quota){
  return (quota.rightFlag==='OK')
}

function quotaErrorHandler(rightFlag){
  if(rightFlag==='KO_LIMIT'){
    modal.ask({
      lottie:"images/lottie/face_with_rolling_eyes.json",
      title:'fw2.apierrors.601.title',
      message:'fw2.apierrors.601.messagepremium',
      button:[
        {title:"actions.contactus",action:"mailto|support@familywall.com"},
        {title:"actions.later",onclick:modal.modalClose,class:"secondary"}
      ]
    });  
  }else{
    modal.ask({
      lottie:"images/lottie/face_with_rolling_eyes.json",
      title:'fw2.apierrors.601.title',
      message:'fw2.apierrors.601.message',
      button:[
        {title:"actions.gopremium",action:"takepremium",class:"premium"},
        {title:"actions.later",onclick:modal.modalClose,class:"secondary"}
        ]
    });  
  }
}